import { trim } from 'lodash';
import { array, mixed, number, object, string } from 'yup';

import {
  BulkCampaignType,
  ConsultType,
  Honorific,
} from '../../../../../data/types/api/graphql';
import { messages } from '../../../../../data/utils/form.utils';
import { UploadFileItemData } from '../../../../../data/utils/upload.utils';

export const schema = object()
  .shape({
    internalTitle: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),
    type: mixed<BulkCampaignType>()
      .oneOf(Object.values(BulkCampaignType))
      .required(messages.required.id),
    titleNl: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),
    titleEn: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),

    messageNl: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),
    messageEn: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),
    fileNl: mixed<UploadFileItemData>().default(null).nullable(),
    fileEn: mixed<UploadFileItemData>().default(null).nullable(),

    // schedule appointment - only required when bulkType is PlanAppointment
    healthProfessionalId: string().transform(trim).default(''),

    consultTypes: array(mixed<ConsultType>().oneOf(Object.values(ConsultType)))
      .when('type', {
        is: BulkCampaignType.PlanAppointment,
        then: s => s.required(messages.required.id),
        otherwise: s => s.optional(),
      })
      .default([ConsultType.Physical]),
    honorifics: array(
      object().shape({
        key: mixed<Honorific>()
          .transform(value => {
            // Handle null/undefined correctly
            if (value === null || value === undefined) {
              return undefined; // Will trigger required validation
            }
            return value;
          })
          .oneOf(Object.values(Honorific))
          .required(messages.required.id),
        value: number().required(messages.required.id),
      })
    ).when('type', {
      is: BulkCampaignType.PlanAppointment,
      then: s => s.required(messages.required.id),
      otherwise: s => s.optional(),
    }),
  })
  .required()
  .noUnknown();
